import React from 'react';
import '../styles/ButtonwithEnter.css';
import {ReactComponent as Spinner} from '../assets/spinner.svg';

export default function ButtonwithEnter({type, width, indexId, text, onClickFn, submitState, showSpan=true}) {
    return (
        <div className='buttonwithenter'>
            <button className={type} style={{width: width}} id={`button${indexId}`} onClick={onClickFn} disabled={submitState}>
                {
                    submitState
                    ?
                    <Spinner stroke='#1b365d'/>
                    :
                    text
                }
            </button>
            {
                showSpan
                &&
                <span>press <b>Enter ↵</b></span>
            }
        </div>
    )
}